var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_16104958",
    clipPath: "url(#clip0_8104_65436)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2 copy 9"
  }, /*#__PURE__*/React.createElement("g", {
    id: 22
  }, /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32.5 64C50.1731 64 64.5 49.6731 64.5 32C64.5 14.3269 50.1731 0 32.5 0C14.8269 0 0.5 14.3269 0.5 32C0.5 49.6731 14.8269 64 32.5 64Z",
    fill: "#00778B"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M50.7961 23.3376L33.4724 40.6626L32.4999 41.6351L27.2849 46.8489L21.0974 40.6626L14.2036 33.7676L20.3911 27.5801L27.2849 34.4751L32.4999 29.2601L44.6086 17.1514L50.7961 23.3376Z",
    fill: "#FFF5F5"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8104_65436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.298629cf364773f7a56235b4eff0f061.svg";
export { ForwardRef as ReactComponent };